import { api } from '../../base';

export interface IScheduleInterviewTimeSlot {
    value: string;
    label: string;
}

export interface IScheduleInterviewSlot {
    date: string;
    display_date: string;
    times: IScheduleInterviewTimeSlot[];
}

export interface IScheduleInterviewResponse {
    candidate_name: string;
    job_title: string;
    company_name: string;
    available_slots: IScheduleInterviewSlot[];
    existing_interview: Record<string, unknown> | null;
    error?: string;
}

export const fetchScheduleInterviewApi = (token: string) => {
    return api.get({
        url: `schedule-interview/?token=${token}`,
    });
};

export const submitScheduleInterviewApi = (
    token: string,
    date: string,
    time: string
) => {
    return api.post({
        url: `schedule-interview/book/?token=${token}`,
        data: { date, time },
    });
};
